import { PATH_PREFIX, SETTINGS_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute, createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute, GlobalHomePageRoute } from '@townsquare/router/route-types';

export const settingsRoute: SiteHomePageRoute = createSiteRoute({
	exact: false,
	name: SETTINGS_PAGE,
	path: `${PATH_PREFIX.SETTINGS}/:pageName/:entity?`,
});

export const noWorkspacePersonalSettingsRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: false,
	name: 'personal settings',
	path: `${PATH_PREFIX.SETTINGS}/personal`,
});
